function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.997 4.193a.534.534 0 00-.322-.424L9.238.049a.593.593 0 00-.476 0L.325 3.77A.534.534 0 000 4.25v9.031c0 .217.14.413.354.493l8.437 3.188a.592.592 0 00.418 0l8.437-3.188a.532.532 0 00.354-.493V4.25l-.003-.057zM9 1.117l7.022 3.095-2.704 1.022-7.154-2.866L9 1.118zM4.792 2.972l7.044 2.822L9 6.865 1.978 4.212l2.814-1.24zM1.125 5.035l7.313 2.762v7.887l-7.313-2.762V5.035zm8.438 10.65V7.796l7.312-2.762v7.887l-7.313 2.762z",
  fill: "#70544F"
});

function SvgCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCube;